export const iconFontAwesomeFilmVideoPhotoFilm = (
	<i className="fa-solid fa-photo-film"></i>
);
